
import { makeStyles } from '@material-ui/core/styles';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { admitAllLobbyParticipants } from '../../lobby/actions.any';
import { setKnockingParticipantApproval } from '../../lobby/actions.web';
import { getLobbyState } from '../../lobby/functions';
import { showNotification } from '../../notifications';

import { LobbyParticipantItem } from './LobbyParticipantItem';

declare var config: object;

const useStyles = makeStyles(() => {
    return {
        headingContainer: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between'
        },
        heading: {
            // ...withPixelLineHeight(theme.typography.heading7),
            color: '#000000'
        },
        link: {
            // ...withPixelLineHeight(theme.typography.labelBold),
            color: '#4687ED',
            cursor: 'pointer'
        },
        listContainer: {
            maxHeight: '25vh',
            overflowY: 'auto',
            overflowX: 'hidden'
        }
    };
});

export const LobbyParticipantList = () => {
    const { lobbyEnabled, knockingParticipants: participants }
        = useSelector(getLobbyState);
    const { t } = useTranslation();
    const totalParticipants = useSelector(state => state['features/base/participants'].length);

    const participantAllowedinMeeting = useSelector(state => state['features/base/jwt']?.meetingDetails?.max_participants);
    const availableSlots = participantAllowedinMeeting - totalParticipants;
    const participantsAllowedToJoin = participants.slice(0, availableSlots);

    const classes = useStyles();
    const dispatch = useDispatch();
    const admitAll = useCallback(() => {
        dispatch(admitAllLobbyParticipants(participantsAllowedToJoin));

        if (participants.length > availableSlots) {

            dispatch(showNotification({
                descriptionArguments: { number: participantAllowedinMeeting },
                descriptionKey: 'notify.participantLimitReachedDes',
                titleKey: 'notify.participantLimitReached',
                customActionNameKey: 'notify.upgradeNow',
                customActionHandler: () => window.open(`${config?.URL_PREFIX}updateSubscription`, '_new')
            }));

            setTimeout(() => {
                participantsAllowedToJoin.map(p => dispatch(setKnockingParticipantApproval(p.id, false)));
            }, 8000);
        }

    }, [ dispatch, participantsAllowedToJoin ]);

    if (!lobbyEnabled || !participants.length) {
        return null;
    }

    return (
        <>
            <div className = { classes.headingContainer }>
                <div className = { classes.heading }>
                    {t('participantsPane.headings.lobby', {
                        count: participants.length
                    })}
                </div>
                <div
                    className = { classes.link }
                    onClick = { admitAll }>
                    {t('lobby.admitAll')}
                </div>
            </div>
            <div className = { classes.listContainer }>
                {participants.map(p =>
                    (<LobbyParticipantItem
                        key = { p.id }
                        participant = { p } />)
                )}
            </div>
        </>
    );
};
